import {
  createStartAction,
  createSuccessAction,
  initialState,
} from '../../redux-util/async-helpers';

const emptyArray = [];

function processUpdate(state = initialState, outputNodeName, id, assigned) {
  if (assigned) {
    const data = state.data ? state.data[outputNodeName] : emptyArray;
    const oldCount = state.data ? state.data.totalElements : 0;
    const index = data.indexOf(id);
    if (index === -1) {
      return {
        ...state,
        data: {
          ...state.data,
          [outputNodeName]: [...data, id],
          totalElements: oldCount + 1,
          // Offset should not be updated since we don't know where it would be in the response
        },
      };
    }
  } else if (!assigned && state.data && state.data[outputNodeName]) {
    const offset = state.data.offset;
    const total = state.data.totalElements;
    const data = state.data[outputNodeName];
    const index = data.indexOf(id);
    if (index !== -1) {
      const newContent = [...data];
      newContent.splice(index, 1);
      return {
        ...state,
        data: {
          ...state.data,
          [outputNodeName]: newContent,
          offset: offset - 1,
          totalElements: total - 1,
        },
      };
    }
  }

  return state;
}

export function getBatchUpdateReducer({
  updateAction,
  paramNodeName,
  itemKeyName,
  outputNodeName,
  useStart,
}) {
  return function(state = {}, action) {
    const actionCreator = useStart ? createStartAction : createSuccessAction;

    if (action.type === actionCreator(updateAction).type) {
      const newState = { ...state };
      const base = useStart ? action.data : action.args;
      const changedAdoptions = base[0].adoptions;
      changedAdoptions.forEach(a => {
        const adoptionId = a.id;
        const items = a[paramNodeName];
        items.forEach(item => {
          newState[adoptionId] = processUpdate(
            newState[adoptionId],
            outputNodeName,
            item[itemKeyName],
            item.assigned
          );
        });
      });
      return newState;
    }
    return state;
  };
}
